import React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect, Route } from 'react-router-dom';
import { PageHero, PageLoader } from '@kambria/kambria-lego';

import TokenPortal from '../token-portal';
import Profile from '../profile/index.js';
import SessionHistory from '../session-history';
import AccountBalance from '../account-balance';
import OrderHistory from '../order-history';
import NftLicense from '../nft-licenses';
import Message from 'views/components/core/message/Message';
import AwsFileUpload from 'views/components/core/AwsFileUpload';

import { fetchUserMvp, updateProfilePicture, getUserProfileMvp } from 'redux/actions/user.action';

import background from 'static/images/token-header.png';
import defaultAvatar from 'static/images/default_avatar.png';
import { I18n } from '../../../../helpers/i18n';

const DEFAULT_PAGE = '/user/profile';

class User extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notificationCount: 0,
    };
    this.inputFileRef = React.createRef();
  }

  style = {
    backgroundImage: `url(${background})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    height: '420px',
  };

  async componentDidMount() {
    Object.keys(this.props.user).length || this.props.fetchUserMvp();
    const { fetchUserMvp, getUserProfileMvp, updateUser } = this.props;
    const user = await getUserProfileMvp();


  }

  uploadDone = async (pictureUri) => {
    const { updateProfilePicture } = this.props;
    await updateProfilePicture(pictureUri);
  };

  onAvatarPickerClick = () => {
    const { updatingProfilePicture } = this.props;
    if (updatingProfilePicture) return;
    this.inputFileRef.current.click();
  };

  renderUserIndex = () => {
    const { user, updatingProfilePicture, editting } = this.props;
    const MENU_ITEMS = [
      {
        linkTo: '/user/profile',
        text: I18n.t('my_account'),
        component: Profile,
      },
      {
        linkTo: '/user/session-history',
        text: I18n.t('session_history'),
        component: SessionHistory,
      },
      // {
      //   linkTo: '/user/account-balance',
      //   text: 'Account Balance',
      //   component: AccountBalance,
      // },
      // {
      //   linkTo: '/user/order-history',
      //   text: 'Order History',
      //   component: OrderHistory,
      // },
      // {
      //   linkTo: '/user/nft-licenses',
      //   text: 'NFT Licenses',
      //   component: NftLicense,
      // },
    ];
    return (
      <main className="main p-4" style={{ backgroundColor: '#F2F2F2' }}>
        <div className="container user-portal shadow-lg">
          <div className="row">
            <div className="col-12 col-lg-3 col-md-3 col-sm-12 p-0 m-0 text-center portal-menu">
              <div
                className="avatar"
                style={{
                  backgroundImage: `url(${user.avatarUrl || defaultAvatar})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                  backgroundSize: 'cover',
                  width: '128px',
                  height: '128px',
                  borderRadius: '50%',
                  margin: '36px auto',
                }}
              >
                {editting && (
                  <div className="avatar-picker" onClick={this.onAvatarPickerClick}>
                    {updatingProfilePicture ? <PageLoader type="position" /> : <i className="fas fa-camera" />}
                    <AwsFileUpload
                      customStyle={{
                        position: 'absolute',
                        left: -9999,
                        top: -9999,
                      }}
                      fileRef={this.inputFileRef}
                      accept=".png, .jpg, .jpeg, .gif"
                      typePattern={/^image\/(png|jpg|jpeg|gif)$/}
                      maxSize={5}
                      path="userprofile/images/"
                      signals={{
                        onStart: 'UPLOAD_IMAGE',
                        onSuccess: 'UPLOAD_IMAGE_SUCCESS',
                        onFailure: 'UPLOAD_IMAGE_FAILED',
                      }}
                      prefix="avatar_"
                      uploadDone={this.uploadDone}
                    />
                  </div>
                )}
              </div>
              <ul className="menu">
                {MENU_ITEMS.map((item) => {
                  const linkClassName = window.location.pathname === item.linkTo ? 'active' : '';
                  return item.invisible && item.invisible(user.investorType) ? null : (
                    <li key={item.linkTo}>
                      <Link className={linkClassName} to={item.linkTo}>
                        {item.text}
                        {item.children && item.children(this.state.notificationCount)}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="col-12 col-lg-9 col-md-9 col-sm-12 p-4 m-0 text-left portal-content">
              {MENU_ITEMS.map((item) => (
                <Route key={item.linkTo} path={item.linkTo} component={item.component} />
              ))}
              <Route exact key="/user" path="/user" component={() => <Redirect to={DEFAULT_PAGE} />} />
            </div>
          </div>
        </div>
      </main>
    );
  };

  render() {
    const { header, footer, user, loading } = this.props;

    return (
      <div id="site_wrapper">
        <Message />
        <div className="site-upper" style={this.style}>
          {header}
          <PageHero />
        </div>
        {loading ? <PageLoader type="center" /> : user && this.renderUserIndex()}
        {footer}
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  user,
  editting: user.editting,
  loading: user.loading,
  updatingProfilePicture: user.updatingProfilePicture,
});

const mapDispatchToProps = (dispatch) => ({
  fetchUserMvp,
  updateProfilePicture,
  getUserProfileMvp
});
export default connect(mapStateToProps, mapDispatchToProps)(User);
